import React from "react"

import Skill from "./Skill"
import figmaIcon from "assets/icons/figma"
import reactIcon from "assets/icons/react-icon"
import nodeIcon from "assets/icons/node"
import sassIcon from "assets/icons/sass"
import pythonIcon from "assets/icons/python"
import uxIcon from "assets/icons/ux"
import "./style.scss"

function Skills() {
	return (
		<div id="skills" className="skills">
			<div className="skills__container">
				<div className="section__title">
					<h3>You can see my skills here</h3>
				</div>
				<div className="skills__lists">
					
					<Skill
						name="Front-end"
						detail="React, Angular, Vue, HTML, CSS, SASS, Bootstrap, REST API, GraphQL"
						icon={reactIcon}
					/>
					<Skill
						name="Back-end"
						detail="Node, Express, Laravel, Django, MySQL, MongoDB, Docker, Google Cloud, AWS"
						icon={nodeIcon}
					/>
					
					<Skill
						name="Mobile"
						detail="Flutter, Dart, React Native, Andriod"
						icon={uxIcon}
					/>
					
					<Skill
						name="DevOps"
						detail="Agile, Scrum, CI/CD, Jira, Postman"
						icon={figmaIcon}
					/>
					<Skill
						name="Program Language"
						detail="Javascript, TypeScript, PHP, Python, Rust, Dart"
						icon={sassIcon}
					/>
					<Skill
						name="Soft Skills"
						detail="Fluent Engilsh, Problem Solving, Detail-Oriented, Time Management, Self-Study"
						icon={pythonIcon}
					/>
				</div>
			</div>
		</div>
	)
}

export default Skills
